export const reducerKey = 'async'
export const cacheKey = 'cache'

export const defaultFixDataBeforNomarlize = (
  data
) => data.data
